import { z } from 'zod';

import { GeographyMapping, geographyMappingSchema, nodeTypeSchema } from '../schema/Node.ts';
import { validateData } from '../utils/utils.ts';
import { api } from './client.ts';
import {
  getGeographyMappingSuggestionUrl,
  getGeographyMappingUpdateUrl,
  getMappedGeographyUrl,
  getShuttleProviderGeographyUrl,
  getTerritoryConsolidatedGeographyUrl,
  triggerGeographyRefreshUrl,
} from './constants.ts';

export async function getTerritoryConsolidatedGeography(territorySlug: string, signal?: AbortSignal) {
  const { data } = await api.get(getTerritoryConsolidatedGeographyUrl(territorySlug), { signal });
  return validateData(z.array(nodeTypeSchema), data, 'Territory consolidated geography');
}

export async function getShuttleProviderGeography(territorySlug: string, signal?: AbortSignal) {
  const { data } = await api.get(getShuttleProviderGeographyUrl(territorySlug), { signal });
  return validateData(z.array(nodeTypeSchema), data, 'Shuttle provider geography');
}

export async function getMappedGeography(
  territorySlug: string,
  territoryIntegrationId: number,
  signal?: AbortSignal,
) {
  const { data } = await api.get(getMappedGeographyUrl(territorySlug, territoryIntegrationId), {
    signal,
  });
  return validateData(z.array(geographyMappingSchema), data, 'Mapping geography');
}

export async function getGeographyMappingSuggestion(
  territorySlug: string,
  territoryIntegrationId: number,
) {
  const { data } = await api.get(
    getGeographyMappingSuggestionUrl(territorySlug, territoryIntegrationId),
  );
  return validateData(z.array(geographyMappingSchema), data, 'Mapping geography');
}
export async function patchGeographyMappingUpdate(
  territorySlug: string,
  territoryIntegrationId: number,
  payload: GeographyMapping[],
) {
  const validatedPayload = validateData(z.array(geographyMappingSchema), payload, 'Mapping geography');
  const { data } = await api.patch(getGeographyMappingUpdateUrl(territorySlug, territoryIntegrationId), {
    mapping: validatedPayload,
  });
  return data;
}
export async function triggerGeographyRefresh(territorySlug: string, territoryIntegrationId: number) {
  return await api.get(triggerGeographyRefreshUrl(territorySlug, territoryIntegrationId));
}
